import { defineComponent as _defineComponent } from 'vue'
import { computed, withDefaults } from 'vue';

type Props = {
    unit?: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'chart-number',
  props: {
    unit: { default: 'MW' }
  },
  setup(__props: any) {

const props = __props as { unit: string };



const value = computed<string>(() => {
    switch (props.unit) {
        case 'm/s': return '7,23';
        case 'KW':
        case 'kW': return '1.680';
        case 'kWh': return '3.290';
        case '%': return '98,1';
        case 'rpm':
        case '°':
        case '°C':
        case 'kVAh':
        case 'V':
        case 'A':
        case 'Hz':
        case 'h':
        case 'mm/h':
        case 'g/m3':
        case 'bar':
        case 'EUR':
        case '€':
        case 'ct/kWh':
        case 'kg':
        case 'km':
        default: return '32,84';
    }
});

return { __sfc: true,props, value }
}

})